module.exports = __webpack_public_path__ + "static/nachalo-745ccb3616c4085eec00c0ec8d2908d9.svg";